import React,{useContext, useMemo} from 'react';

import {
    Tab,Box
} from '@mui/material';

import {
    TabList,
    TabContext
 } from '@mui/lab';
 import CloseIcon from '@mui/icons-material/Close';
 import HomeIcon from '@mui/icons-material/Home';
 import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import { DatabaseContext } from '../redux/DatabaseStore';
import { LocaleContext } from './LocaleContext';
import { resolveTabLabel } from '../utils/tabTitle';
import HomePage from '../pages/HomePage';
import InternaChyba from '../pages/otk/InternaChyba';
import ExternaChyba from '../pages/otk/ExternaChyba';
import Reklamacia from '../pages/otk/Reklamacia';
import ZoznamInt from '../pages/otk/ZoznamInt';
import ZoznamExt from '../pages/otk/ZoznamExt';
import ZoznamRek from '../pages/otk/ZoznamRek';
import ProfilePage from '../pages/ProfilePage';
import DocumentationAdd from '../pages/otk/DocumentationAdd';
import Documentation from '../pages/otk/Documentation';
import DocumentationDetail from '../pages/otk/DocumentationDetail';
import MeasurementProtocol from '../pages/otk/MeasurementProtocol';
import SelfControl from '../pages/otk/SelfControl';
import NDTProtocol from '../pages/otk/NDTProtocol';
import AnnealingProtocol from '../pages/otk/AnnealingProtocol';
import CustomerList from '../pages/options/CustomerList';
import CustomerAdd from '../pages/options/CustomerAdd';
import SupplierAdd from '../pages/options/SupplierAdd';
import SupplierList from '../pages/options/SupplierList';
import EmployeeList from '../pages/options/EmployeeList';
import UserList from '../pages/options/UserList';
import UserAdd from '../pages/options/UserAdd';
import RoleList from '../pages/options/RoleList';
import RoleAdd from '../pages/options/RoleAdd';
import TabPanel from './TabPanel';
import EmployeeAdd from '../pages/options/EmployeeAdd';
import OtkCompanyCertificateAdd from '../pages/otk/companies/OtkCompanyCertificateAdd';
import OtkCompanyCertificateList from '../pages/otk/companies/OtkCompanyCertificateList';
import OtkCompanyCertRecordAdd from '../pages/otk/companies/OtkCompanyCertRecordAdd';
import OtkCompanyCertRecordDetail from '../pages/otk/companies/OtkCompanyCertRecordDetail';
import OtkCompanyCertRecordList from '../pages/otk/companies/OtkCompanyCertRecordList';
import OtkCompanyCertStateList from '../pages/otk/companies/OtkCompanyCertStateList';
import OtkCompanyCardList from '../pages/otk/companies/OtkCompanyCardList';
import OtkCompanyCardDetail from '../pages/otk/companies/OtkCompanyCardDetail';
import PaintingIntervalAdd from '../pages/painting/options/PaintingIntervalAdd';
import PaintingIntervalList from '../pages/painting/options/PaintingIntervalList';
import PaintingConditionAdd from '../pages/painting/PaintingConditionAdd';
import PaintingConditionList from '../pages/painting/PaintingConditionList';
import PaintingTimeConditionAdd from '../pages/painting/options/PaintingTimeConditionAdd';
import PaintingTimeConditionList from '../pages/painting/options/PaintingTimeConditionList';
import PaintingEmployeeConditionAdd from '../pages/painting/options/PaintingEmployeeConditionAdd';
import PaintingEmployeeConditionList from '../pages/painting/options/PaintingEmployeeConditionList';
import DepartmentList from '../pages/options/DepartmentList';
import DepartmentAdd from '../pages/options/DepartmentAdd';
import GaugeList from '../pages/calibration/GaugeList';
import GaugeAdd from '../pages/calibration/GaugeAdd';
import GaugeCalibrationList from '../pages/calibration/GaugeCalibrationList';
import CalibrationStateList from '../pages/calibration/CalibrationStateList';
import GaugeCalibrationAdd from '../pages/calibration/GaugeCalibrationAdd';
import CalibrationCompanyCertificateList from '../pages/calibration/companies/CalibrationCompanyCertificateList';
import CalibrationCompanyCardList from '../pages/calibration/companies/CalibrationCompanyCardList';
import CalibrationCompanyCertificateAdd from '../pages/calibration/companies/CalibrationCompanyCertificateAdd';
import CalibrationCompanyCardDetail from '../pages/calibration/companies/CalibrationCompanyCardDetail';
import PriorityList from '../pages/priorities/PriorityList';
import PriorityListMobile from '../pages/priorities/PriorityListMobile';
import PriorityAdd from '../pages/priorities/PriorityAdd';
import PriorityDepartmentAdd from '../pages/priorities/options/PriorityDepartmentAdd';
import PriorityDepartmentList from '../pages/priorities/options/PriorityDepartmentList';
import PriorityLoadAutomaticList from '../pages/priorities/options/PriorityLoadAutomaticList';
import PriorityLoadManuallyList from '../pages/priorities/options/PriorityLoadManuallyList';
import PriorityLoadAdd from '../pages/priorities/options/PriorityLoadAdd';
import ErrorTypeList from '../pages/otk/options/ErrorTypeList';
import ErrorTypeAdd from '../pages/otk/options/ErrorTypeAdd';
import ProtocolTypeList from '../pages/otk/options/ProtocolTypeList';
import ProtocolTypeAdd from '../pages/otk/options/ProtocolTypeAdd';
import RootCauseList from '../pages/otk/options/RootCauseList';
import RootCauseAdd from '../pages/otk/options/RootCauseAdd';
import PreventionList from '../pages/otk/options/PreventionList';
import PreventionAdd from '../pages/otk/options/PreventionAdd';
import GroupList from '../pages/otk/options/GroupList';
import GroupAdd from '../pages/otk/options/GroupAdd';
import MeasureComplexityList from '../pages/otk/options/MeasureComplexityList';
import MeasureComplexityAdd from '../pages/otk/options/MeasureComplexityAdd';
import SummaryEmailOTKList from '../pages/otk/options/SummaryEmailOTKList';
import SummaryEmailOTKAdd from '../pages/otk/options/SummaryEmailOTKAdd';
import WeatherList from '../pages/painting/options/WeatherList';
import WeatherAdd from '../pages/painting/options/WeatherAdd';
import SummaryEmailPaintingList from '../pages/painting/options/SummaryEmailPaintingList';
import SummaryEmailPaintingAdd from '../pages/painting/options/SummaryEmailPaintingAdd';
import CalibrationGeneralSettings from '../pages/calibration/options/CalibrationGeneralSettings';
import SummaryEmailCalibrationList from '../pages/calibration/options/SummaryEmailCalibrationList';
import SummaryEmailCalibrationAdd from '../pages/calibration/options/SummaryEmailCalibrationAdd';
import TrainingCompanyList from '../pages/training/companies/TrainingCompanyList';
import TrainingCompanyAdd from '../pages/training/companies/TrainingCompanyAdd';
import TrainingCompanyContactList from '../pages/training/companies/TrainingCompanyContactList';
import TrainingCompanyContactAdd from '../pages/training/companies/TrainingCompanyContactAdd';
import TrainingCompanyCertificateAdd from '../pages/training/companies/TrainingCompanyCertificateAdd';
import TrainingCompanyCertificateList from '../pages/training/companies/TrainingCompanyCertificateList';
import TrainingCompanyCardList from '../pages/training/companies/TrainingCompanyCardList';
import TrainingCompanyCardDetail from '../pages/training/companies/TrainingCompanyCardDetail';
import TrainingCompanyCertRecordAdd from '../pages/training/companies/TrainingCompanyCertRecordAdd';
import TrainingCompanyCertRecordDetail from '../pages/training/companies/TrainingCompanyCertRecordDetail';
import TrainingCompanyCertRecordList from '../pages/training/companies/TrainingCompanyCertRecordList';
import TrainingCompanyCertStateList from '../pages/training/companies/TrainingCompanyCertStateList';
import TrainingTypeList from '../pages/training/TrainingTypeList';
import TrainingTypeAdd from '../pages/training/TrainingTypeAdd';
import TrainingTemplateList from '../pages/training/templates/TrainingTemplateList';
import TrainingTemplateAdd from '../pages/training/templates/TrainingTemplateAdd';
import TrainingTemplateRecordList from '../pages/training/templates/TrainingTemplateRecordList';
import TrainingTemplateRecordAdd from '../pages/training/templates/TrainingTemplateRecordAdd';
import TrainingRecordAdd from '../pages/training/TrainingRecordAdd';
import TrainingRecordList from '../pages/training/TrainingRecordList';
import TrainingRecordDetail from '../pages/training/TrainingRecordDetail';
import TrainingCardAdd from '../pages/training/TrainingCardAdd';
import TrainingCardList from '../pages/training/TrainingCardList';
import TrainingCardDetail from '../pages/training/TrainingCardDetail';
import TrainingEmployeeList from '../pages/training/TrainingEmployeeList';
import TrainingEmployeeDetail from '../pages/training/TrainingEmployeeDetail';
import TrainingStateList from '../pages/training/TrainingStateList';
import PreviewOTK from '../pages/otk/PreviewOTK';
import PreviewLak from '../pages/painting/PreviewLak';
import PreviewCal from '../pages/calibration/PreviewCal';
import PreviewTraining from '../pages/training/PreviewTraining';
import PreviewMaintenance from '../pages/maintenance/PreviewMaintenance';
import SupportTicketAdd from '../pages/support/SupportTicketAdd';
import SupportTicketList from '../pages/support/SupportTicketList';
import SupportTicketDetail from '../pages/support/SupportTicketDetail';
import OTKStatistics from '../pages/otk/output/OTKStatistics';
import OTKEvaluation from '../pages/otk/output/OTKEvaluation';
import OtkStatisticsSettings from '../pages/otk/options/OtkStatisticsSettings';
import OtkGeneralSettings from '../pages/otk/options/OtkGeneralSettings';
import TrainingInvitationTemplateAdd from '../pages/training/invitations/TrainingInvitationTemplateAdd';
import TrainingInvitationTemplateList from '../pages/training/invitations/TrainingInvitationTemplateList';
import TrainingInvitationAdd from '../pages/training/invitations/TrainingInvitationAdd';
import TrainingInvitationList from '../pages/training/invitations/TrainingInvitationList';
import TrainingGeneralSettings from '../pages/training/options/TrainingGeneralSettings';
import SummaryEmailTrainingList from '../pages/training/options/SummaryEmailTrainingList';
import SummaryEmailTrainingAdd from '../pages/training/options/SummaryEmailTrainingAdd';
import ServiceTaskAdd from '../pages/service/ServiceTaskAdd';
import ServiceTaskList from '../pages/service/ServiceTaskList';
import ServiceTaskAllList from '../pages/service/ServiceTaskAllList';
import ServiceTaskDetail from '../pages/service/ServiceTaskDetail';
import ServiceUsersSettings from '../pages/service/options/ServiceUsersSettings';
import ServiceGeneralSettings from '../pages/service/options/ServiceGeneralSettings';
import ServiceStateAdd from '../pages/service/options/ServiceStateAdd';
import ServiceStateList from '../pages/service/options/ServiceStateList';
import TaskTemplateList from '../pages/service/options/TaskTemplateList';
import TaskTemplateAdd from '../pages/service/options/TaskTemplateAdd';
import MachineAdd from '../pages/options/MachineAdd';
import MachineList from '../pages/options/MachineList';
import MachineTypeAdd from '../pages/options/MachineTypeAdd';
import MachineTypeList from '../pages/options/MachineTypeList';
import BusinessPartnerAdd from '../pages/options/BusinessPartnerAdd';
import BusinessPartnerList from '../pages/options/BusinessPartnerList';
import LecturerAdd from '../pages/training/options/LecturerAdd';
import LecturerList from '../pages/training/options/LecturerList';
import CalibrationCompanyCertRecordAdd from '../pages/calibration/companies/CalibrationCompanyCertRecordAdd';
import CalibrationCompanyCertRecordDetail from '../pages/calibration/companies/CalibrationCompanyCertRecordDetail';
import CalibrationCompanyCertRecordList from '../pages/calibration/companies/CalibrationCompanyCertRecordList';
import CalibrationCompanyCertStateList from '../pages/calibration/companies/CalibrationCompanyCertStateList';
import ChecklistTemplateAdd from '../pages/checklists/options/ChecklistTemplateAdd';
import ChecklistTemplateList from '../pages/checklists/options/ChecklistTemplateList';
import ChecklistRecordList from '../pages/checklists/ChecklistRecordList';
import ChecklistRecordAdd from '../pages/checklists/ChecklistRecordAdd';
import ChecklistStateList from '../pages/checklists/ChecklistStateList';
import ChecklistStateDetail from '../pages/checklists/ChecklistStateDetail';
import ChecklistRecordMyList from '../pages/checklists/ChecklistRecordMyList';
import ChecklistRecordMyDetail from '../pages/checklists/ChecklistRecordMyDetail';
import PreviewChecklists from '../pages/checklists/PreviewChecklists';
import PreviewServiceTask from '../pages/service/PreviewServiceTask';
import ChecklistRecordAllList from '../pages/checklists/ChecklistRecordAllList';
import ChecklistRecordAllDetail from '../pages/checklists/ChecklistRecordAllDetail';
import SummaryEmailChecklistList from '../pages/checklists/options/SummaryEmailChecklistList';
import SummaryEmailChecklistAdd from '../pages/checklists/options/SummaryEmailChecklistAdd';
import ChecklistHolidayList from '../pages/checklists/options/ChecklistHolidayList';
import ChecklistHolidayAdd from '../pages/checklists/options/ChecklistHolidayAdd';
import ChecklistGeneralSettings from '../pages/checklists/options/ChecklistGeneralSettings';
import MaintenanceCompanyContactList from '../pages/maintenance/companies/MaintenanceCompanyContactList';
import MaintenanceCompanyContactAdd from '../pages/maintenance/companies/MaintenanceCompanyContactAdd';
import MaintenanceCompanyCertificateAdd from '../pages/maintenance/companies/MaintenanceCompanyCertificateAdd';
import MaintenanceCompanyCertificateList from '../pages/maintenance/companies/MaintenanceCompanyCertificateList';
import MaintenanceCompanyCardList from '../pages/maintenance/companies/MaintenanceCompanyCardList';
import MaintenanceCompanyCardDetail from '../pages/maintenance/companies/MaintenanceCompanyCardDetail';
import MaintenanceCompanyCertRecordAdd from '../pages/maintenance/companies/MaintenanceCompanyCertRecordAdd';
import MaintenanceCompanyCertRecordDetail from '../pages/maintenance/companies/MaintenanceCompanyCertRecordDetail';
import MaintenanceCompanyCertRecordList from '../pages/maintenance/companies/MaintenanceCompanyCertRecordList';
import MaintenanceCompanyCertStateList from '../pages/maintenance/companies/MaintenanceCompanyCertStateList';
import OtkCompanyStatisticsList from '../pages/otk/companies/OtkCompanyStatisticsList';
import OtkCompanyStatisticsAdd from '../pages/otk/companies/OtkCompanyStatisticsAdd';
import OtkCompanyStatisticsPeriodList from '../pages/otk/companies/OtkCompanyStatisticsPeriodList';
import OtkCompanyStatisticsPeriodAdd from '../pages/otk/companies/OtkCompanyStatisticsPeriodAdd';
import MaintenanceTypeList from '../pages/maintenance/MaintenanceTypeList';
import MaintenanceTypeAdd from '../pages/maintenance/MaintenanceTypeAdd';
import MaintenanceTemplateList from '../pages/maintenance/templates/MaintenanceTemplateList';
import MaintenanceTemplateAdd from '../pages/maintenance/templates/MaintenanceTemplateAdd';
import MaintenanceTemplateRecordList from '../pages/maintenance/templates/MaintenanceTemplateRecordList';
import MaintenanceTemplateRecordAdd from '../pages/maintenance/templates/MaintenanceTemplateRecordAdd';
import MaintenanceCardList from '../pages/maintenance/MaintenanceCardList';
import MaintenanceMachineStateList from '../pages/maintenance/MaintenanceMachineStateList';
import MaintenanceMachineStateDetail from '../pages/maintenance/MaintenanceMachineStateDetail';
import MaintenanceCardAdd from '../pages/maintenance/MaintenanceCardAdd';
import MaintenanceCardDetail from '../pages/maintenance/MaintenanceCardDetail';
import MaintenanceRecordAdd from '../pages/maintenance/MaintenanceRecordAdd';
import MaintenanceRecordList from '../pages/maintenance/MaintenanceRecordList';
import MaintenanceRecordDetail from '../pages/maintenance/MaintenanceRecordDetail';
import MaintenanceMachineList from '../pages/maintenance/MaintenanceMachineList';
import MaintenanceMachineDetail from '../pages/maintenance/MaintenanceMachineDetail';
import MaintenanceStateList from '../pages/maintenance/MaintenanceStateList';
import MaintenanceTaskRecordList from '../pages/maintenance/MaintenanceTaskRecordList';
import MaintenanceTaskRecordDetail from '../pages/maintenance/MaintenanceTaskRecordDetail';
import MaintenanceTaskStateList from '../pages/maintenance/MaintenanceTaskStateList';
import MaintenanceCheckRecordList from '../pages/maintenance/MaintenanceCheckRecordList';
import MaintenanceCheckRecordDetail from '../pages/maintenance/MaintenanceCheckRecordDetail';
import MaintenanceCheckStateList from '../pages/maintenance/MaintenanceCheckStateList';
import MaintenanceNeedRecordList from '../pages/maintenance/MaintenanceNeedRecordList';
import MaintenanceNeedRecordDetail from '../pages/maintenance/MaintenanceNeedRecordDetail';
import MaintenanceNeedStateList from '../pages/maintenance/MaintenanceNeedStateList';
import SummaryEmailMaintenanceList from '../pages/maintenance/options/SummaryEmailMaintenanceList';
import SummaryEmailMaintenanceAdd from '../pages/maintenance/options/SummaryEmailMaintenanceAdd';
import MaintenanceGeneralSettings from '../pages/maintenance/options/MaintenanceGeneralSettings';
import UnitsSettings from '../pages/options/UnitsSettings';
import CompanySettings from '../pages/options/CompanySettings';
import CustomerEvaluationList from '../pages/crm/CustomerEvaluationList';
import CustomerEvaluationCompleteList from '../pages/crm/CustomerEvaluationCompleteList';
import CustomerEvaluationSettings from '../pages/crm/CustomerEvaluationSettings';
import CustomerProductionQuality from '../pages/crm/CustomerProductionQuality';
import CustomerSalesEvaluation from '../pages/crm/CustomerSalesEvaluation';
import CustomerGeneralSettings from '../pages/crm/CustomerGeneralSettings';
import CustomerLevelsSettings from '../pages/crm/CustomerLevelsSettings';
import CustomerStatesSettings from '../pages/crm/CustomerStatesSettings';
import CustomerTradersSettings from '../pages/crm/CustomerTradersSettings';
import CustomerStatesList from '../pages/crm/CustomerStatesList';
import CustomerStepsList from '../pages/crm/CustomerStepsList';
import CustomerStepsAdd from '../pages/crm/CustomerStepsAdd';
import CustomerStatesAdd from '../pages/crm/CustomerStatesAdd';
import CustomerTradersList from '../pages/crm/CustomerTradersList';
import CustomerTradersAdd from '../pages/crm/CustomerTradersAdd';
import CustomerCentralDatabaseList from '../pages/crm/CustomerCentralDatabaseList';
import CustomerCentralDatabaseAdd from '../pages/crm/CustomerCentralDatabaseAdd';
import CustomerMyCustomersList from '../pages/crm/CustomerMyCustomersList';
import CustomerMyCustomersDetail from '../pages/crm/CustomerMyCustomersDetail';
import CustomerAllPartnersList from '../pages/crm/CustomerAllPartnersList';
import CustomerAllPartnersDetail from '../pages/crm/CustomerAllPartnersDetail';
import CustomerMyBusinessByCustomerList from '../pages/crm/CustomerMyBusinessByCustomerList';
import CustomerMyBusinessByCustomerDetail from '../pages/crm/CustomerMyBusinessByCustomerDetail';
import CustomerMyBusinessByStateList from '../pages/crm/CustomerMyBusinessByStateList';
import CustomerAllBusinessByCustomerList from '../pages/crm/CustomerAllBusinessByCustomerList';
import CustomerAllBusinessByCustomerDetail from '../pages/crm/CustomerAllBusinessByCustomerDetail';
import CustomerAllBusinessByStateList from '../pages/crm/CustomerAllBusinessByStateList';
import CustomerMyAcquisitionByCustomerList from '../pages/crm/CustomerMyAcquisitionByCustomerList';
import CustomerMyAcquisitionByCustomerDetail from '../pages/crm/CustomerMyAcquisitionByCustomerDetail';
import CustomerMyAcquisitionByStateList from '../pages/crm/CustomerMyAcquisitionByStateList';
import CustomerAllAcquisitionByCustomerList from '../pages/crm/CustomerAllAcquisitionByCustomerList';
import CustomerAllAcquisitionByCustomerDetail from '../pages/crm/CustomerAllAcquisitionByCustomerDetail';
import CustomerAllAcquisitionByStateList from '../pages/crm/CustomerAllAcquisitionByStateList';
import CrmCommunicationNewTaskHub from '../pages/crm/CrmCommunicationNewTaskHub';
import CrmCommunicationTicketsList from '../pages/crm/CrmCommunicationTicketsList';
import CrmCommunicationMyAgendaList from '../pages/crm/CrmCommunicationMyAgendaList';
import CrmCommunicationCompleteList from '../pages/crm/CrmCommunicationCompleteList';
import CrmCommunicationTicketDetail from '../pages/crm/CrmCommunicationTicketDetail';
import CrmCommunicationTicketForm from '../pages/crm/CrmCommunicationTicketForm';
import PreviewCrmCommunication from '../pages/crm/PreviewCrmCommunication';

export const components = {
    "InternaChyba": InternaChyba,
    "HomePage": HomePage,
    "ProfilePage": ProfilePage,
    "ExternaChyba" : ExternaChyba,
    "Reklamacia" : Reklamacia,
    "ZoznamInt": ZoznamInt,
    "ZoznamExt": ZoznamExt,
    "ZoznamRek": ZoznamRek,
    "PreviewOTK": PreviewOTK,
    "RoleList": RoleList,
    "DocumentationAdd": DocumentationAdd,
    "Documentation": Documentation,
    "MeasurementProtocol": MeasurementProtocol,
    "SelfControl": SelfControl,
    "NDTProtocol": NDTProtocol,
    "AnnealingProtocol": AnnealingProtocol,
    "SupplierAdd": SupplierAdd,
    "SupplierList": SupplierList,
    "CustomerList": CustomerList,
    "CustomerAdd": CustomerAdd,
    "EmployeeList": EmployeeList,
    "EmployeeAdd": EmployeeAdd,
    "UserList": UserList,
    "UserAdd": UserAdd,
    "RoleAdd": RoleAdd,
    "PreviewLak": PreviewLak,
    "OtkCompanyCertificateList": OtkCompanyCertificateList,
    "OtkCompanyCertificateAdd": OtkCompanyCertificateAdd,
    "OtkCompanyCertRecordAdd": OtkCompanyCertRecordAdd,
    "OtkCompanyCertRecordDetail": OtkCompanyCertRecordDetail,
    "OtkCompanyCertRecordList": OtkCompanyCertRecordList,
    "OtkCompanyCertStateList": OtkCompanyCertStateList,
    "OtkCompanyCardList": OtkCompanyCardList,
    "OtkCompanyCardDetail": OtkCompanyCardDetail,
    "PaintingIntervalAdd": PaintingIntervalAdd,
    "PaintingIntervalList": PaintingIntervalList,
    "PaintingConditionAdd": PaintingConditionAdd,
    "PaintingConditionList": PaintingConditionList,
    "PaintingTimeConditionAdd": PaintingTimeConditionAdd,
    "PaintingTimeConditionList": PaintingTimeConditionList,
    "PaintingEmployeeConditionAdd": PaintingEmployeeConditionAdd,
    "PaintingEmployeeConditionList": PaintingEmployeeConditionList,
    "WeatherList": WeatherList,
    "WeatherAdd": WeatherAdd,
    "DepartmentList": DepartmentList,
    "DepartmentAdd": DepartmentAdd,
    "PreviewCal": PreviewCal,
    "GaugeList": GaugeList,
    "GaugeAdd": GaugeAdd,
    "GaugeCalibrationList": GaugeCalibrationList,
    "CalibrationStateList": CalibrationStateList,
    "GaugeCalibrationAdd": GaugeCalibrationAdd,
    "DocumentationDetail": DocumentationDetail,
    "PriorityList": PriorityList,
    "PriorityListMobile": PriorityListMobile,
    "PriorityAdd": PriorityAdd,
    "PriorityDepartmentList": PriorityDepartmentList,
    "PriorityDepartmentAdd": PriorityDepartmentAdd,
    "PriorityLoadAutomaticList": PriorityLoadAutomaticList,
    "PriorityLoadManuallyList": PriorityLoadManuallyList,
    "PriorityLoadAdd": PriorityLoadAdd,
    "ErrorTypeList": ErrorTypeList,
    "ErrorTypeAdd": ErrorTypeAdd,
    "ProtocolTypeList": ProtocolTypeList,
    "ProtocolTypeAdd": ProtocolTypeAdd,
    "RootCauseList": RootCauseList,
    "RootCauseAdd": RootCauseAdd,
    "PreventionList": PreventionList,
    "PreventionAdd": PreventionAdd,
    "GroupList": GroupList,
    "GroupAdd": GroupAdd,
    "MeasureComplexityList": MeasureComplexityList,
    "MeasureComplexityAdd": MeasureComplexityAdd,
    "SummaryEmailOTKList": SummaryEmailOTKList,
    "SummaryEmailOTKAdd": SummaryEmailOTKAdd,
    "SummaryEmailPaintingList": SummaryEmailPaintingList,
    "SummaryEmailPaintingAdd": SummaryEmailPaintingAdd,
    "CalibrationGeneralSettings": CalibrationGeneralSettings,
    "SummaryEmailCalibrationList": SummaryEmailCalibrationList,
    "SummaryEmailCalibrationAdd": SummaryEmailCalibrationAdd,
    "TrainingCompanyList": TrainingCompanyList,
    "TrainingCompanyAdd": TrainingCompanyAdd,
    "TrainingCompanyContactList": TrainingCompanyContactList,
    "TrainingCompanyContactAdd": TrainingCompanyContactAdd,
    "TrainingTypeList": TrainingTypeList,
    "TrainingTypeAdd": TrainingTypeAdd,
    "TrainingTemplateList": TrainingTemplateList,
    "TrainingTemplateAdd": TrainingTemplateAdd,
    "TrainingTemplateRecordList": TrainingTemplateRecordList,
    "TrainingTemplateRecordAdd": TrainingTemplateRecordAdd,
    "TrainingRecordAdd": TrainingRecordAdd,
    "TrainingRecordList": TrainingRecordList,
    "TrainingRecordDetail": TrainingRecordDetail,
    "TrainingCardAdd": TrainingCardAdd,
    "TrainingCardList": TrainingCardList,
    "TrainingCardDetail": TrainingCardDetail,
    "TrainingEmployeeList": TrainingEmployeeList,
    "TrainingEmployeeDetail": TrainingEmployeeDetail,
    "TrainingStateList": TrainingStateList,
    "TrainingCompanyCertificateList": TrainingCompanyCertificateList,
    "TrainingCompanyCertificateAdd": TrainingCompanyCertificateAdd,
    "TrainingCompanyCertRecordAdd": TrainingCompanyCertRecordAdd,
    "TrainingCompanyCertRecordDetail": TrainingCompanyCertRecordDetail,
    "TrainingCompanyCertRecordList": TrainingCompanyCertRecordList,
    "TrainingCompanyCertStateList": TrainingCompanyCertStateList,
    "TrainingCompanyCardList": TrainingCompanyCardList,
    "TrainingCompanyCardDetail": TrainingCompanyCardDetail,
    "TrainingInvitationTemplateList": TrainingInvitationTemplateList,
    "TrainingInvitationTemplateAdd": TrainingInvitationTemplateAdd,
    "TrainingInvitationList": TrainingInvitationList,
    "TrainingInvitationAdd": TrainingInvitationAdd,
    "PreviewTraining": PreviewTraining,
    "SummaryEmailTrainingList": SummaryEmailTrainingList,
    "SummaryEmailTrainingAdd": SummaryEmailTrainingAdd,
    "SupportTicketAdd": SupportTicketAdd,
    "SupportTicketList": SupportTicketList,
    "SupportTicketDetail": SupportTicketDetail,
    "OTKStatistics": OTKStatistics,
    "OTKEvaluation": OTKEvaluation,
  "OtkStatisticsSettings": OtkStatisticsSettings,
  "OtkGeneralSettings": OtkGeneralSettings,
    "TrainingGeneralSettings": TrainingGeneralSettings,
    "ServiceTaskAdd": ServiceTaskAdd,
    "ServiceTaskList": ServiceTaskList,
    "ServiceTaskAllList": ServiceTaskAllList,
    "ServiceTaskDetail": ServiceTaskDetail,
    "ServiceUsersSettings": ServiceUsersSettings,
    "ServiceGeneralSettings": ServiceGeneralSettings,
    "ServiceStateAdd": ServiceStateAdd,
    "ServiceStateList": ServiceStateList,
    "TaskTemplateList": TaskTemplateList,
    "TaskTemplateAdd": TaskTemplateAdd,
    "MachineAdd": MachineAdd,
    "MachineList": MachineList,
    "MachineTypeAdd": MachineTypeAdd,
    "MachineTypeList": MachineTypeList,
    "BusinessPartnerAdd": BusinessPartnerAdd,
    "BusinessPartnerList": BusinessPartnerList,
    "LecturerAdd": LecturerAdd,
    "LecturerList": LecturerList,
    "CalibrationCompanyCertificateAdd": CalibrationCompanyCertificateAdd,
    "CalibrationCompanyCertificateList": CalibrationCompanyCertificateList,
    "CalibrationCompanyCardList": CalibrationCompanyCardList,
    "CalibrationCompanyCardDetail": CalibrationCompanyCardDetail,
    "CalibrationCompanyCertRecordAdd": CalibrationCompanyCertRecordAdd,
    "CalibrationCompanyCertRecordDetail": CalibrationCompanyCertRecordDetail,
    "CalibrationCompanyCertRecordList": CalibrationCompanyCertRecordList,
    "CalibrationCompanyCertStateList": CalibrationCompanyCertStateList,
    "ChecklistTemplateAdd": ChecklistTemplateAdd,
    "ChecklistTemplateList": ChecklistTemplateList,
    "ChecklistRecordList": ChecklistRecordList,
    "ChecklistRecordAdd": ChecklistRecordAdd,
    "ChecklistStateList": ChecklistStateList,
    "ChecklistStateDetail": ChecklistStateDetail,
    "PreviewChecklists": PreviewChecklists,
    "PreviewServiceTask": PreviewServiceTask,
    "ChecklistRecordMyList": ChecklistRecordMyList,
    "ChecklistRecordMyDetail": ChecklistRecordMyDetail,
    "ChecklistRecordAllList": ChecklistRecordAllList,
    "ChecklistRecordAllDetail": ChecklistRecordAllDetail,
    "SummaryEmailChecklistAdd": SummaryEmailChecklistAdd,
    "SummaryEmailChecklistList": SummaryEmailChecklistList,
    "ChecklistHolidayList": ChecklistHolidayList,
    "ChecklistHolidayAdd": ChecklistHolidayAdd,
    "ChecklistGeneralSettings": ChecklistGeneralSettings,
    "MaintenanceCompanyCertificateList": MaintenanceCompanyCertificateList,
    "MaintenanceCompanyCardList": MaintenanceCompanyCardList,
    "MaintenanceCompanyCardDetail": MaintenanceCompanyCardDetail,
    "MaintenanceCompanyCertificateAdd": MaintenanceCompanyCertificateAdd,
    "MaintenanceCompanyCertRecordAdd": MaintenanceCompanyCertRecordAdd,
    "MaintenanceCompanyCertRecordDetail": MaintenanceCompanyCertRecordDetail,
    "MaintenanceCompanyCertRecordList": MaintenanceCompanyCertRecordList,
    "MaintenanceCompanyCertStateList": MaintenanceCompanyCertStateList,
    "MaintenanceCompanyContactList": MaintenanceCompanyContactList,
    "MaintenanceCompanyContactAdd": MaintenanceCompanyContactAdd,
    "OtkCompanyStatisticsList": OtkCompanyStatisticsList,
    "OtkCompanyStatisticsAdd": OtkCompanyStatisticsAdd,
    "OtkCompanyStatisticsPeriodList": OtkCompanyStatisticsPeriodList,
    "OtkCompanyStatisticsPeriodAdd": OtkCompanyStatisticsPeriodAdd,
    "MaintenanceTypeList": MaintenanceTypeList,
    "MaintenanceTypeAdd": MaintenanceTypeAdd,
    "MaintenanceTemplateList": MaintenanceTemplateList,
    "MaintenanceTemplateAdd": MaintenanceTemplateAdd,
    "MaintenanceTemplateRecordList": MaintenanceTemplateRecordList,
    "MaintenanceTemplateRecordAdd": MaintenanceTemplateRecordAdd,
    "MaintenanceCardList": MaintenanceCardList,
    "MaintenanceMachineStateList": MaintenanceMachineStateList,
    "MaintenanceMachineStateDetail": MaintenanceMachineStateDetail,
    "MaintenanceCardAdd": MaintenanceCardAdd,
    "MaintenanceCardDetail": MaintenanceCardDetail,
    "MaintenanceRecordAdd": MaintenanceRecordAdd,
    "MaintenanceRecordList": MaintenanceRecordList,
    "MaintenanceRecordDetail": MaintenanceRecordDetail,
    "MaintenanceMachineList": MaintenanceMachineList,
    "MaintenanceMachineDetail": MaintenanceMachineDetail,
    "MaintenanceStateList": MaintenanceStateList,
    "MaintenanceTaskRecordList": MaintenanceTaskRecordList,
    "MaintenanceTaskRecordDetail": MaintenanceTaskRecordDetail,
    "MaintenanceTaskStateList": MaintenanceTaskStateList,
    "MaintenanceCheckRecordList": MaintenanceCheckRecordList,
    "MaintenanceCheckRecordDetail": MaintenanceCheckRecordDetail,
    "MaintenanceCheckStateList": MaintenanceCheckStateList,
    "MaintenanceNeedRecordList": MaintenanceNeedRecordList,
    "MaintenanceNeedRecordDetail": MaintenanceNeedRecordDetail,
    "MaintenanceNeedStateList": MaintenanceNeedStateList,
    "SummaryEmailMaintenanceList": SummaryEmailMaintenanceList,
    "SummaryEmailMaintenanceAdd": SummaryEmailMaintenanceAdd,
    "PreviewMaintenance": PreviewMaintenance,
    "MaintenanceGeneralSettings": MaintenanceGeneralSettings,
    "CompanySettings": CompanySettings,
    "UnitsSettings": UnitsSettings,
    "CustomerEvaluationList": CustomerEvaluationList,
    "CustomerEvaluationCompleteList": CustomerEvaluationCompleteList,
    "CustomerEvaluationSettings": CustomerEvaluationSettings,
    "CustomerProductionQuality": CustomerProductionQuality,
    "CustomerSalesEvaluation": CustomerSalesEvaluation,
    "CustomerGeneralSettings": CustomerGeneralSettings,
    "CustomerLevelsSettings": CustomerLevelsSettings,
    "CustomerStatesSettings": CustomerStatesSettings,
    "CustomerTradersSettings": CustomerTradersSettings,
    "CustomerLevelsList": CustomerLevelsSettings,
    "CustomerLevelsAdd": CustomerLevelsSettings,
    "CustomerStatesList": CustomerStatesList,
    "CustomerStepsList": CustomerStepsList,
    "CustomerStepsAdd": CustomerStepsAdd,
    "CustomerStatesAdd": CustomerStatesAdd,
    "CustomerTradersList": CustomerTradersList,
    "CustomerTradersAdd": CustomerTradersAdd,
    "CustomerCentralDatabaseList": CustomerCentralDatabaseList,
    "CustomerCentralDatabaseAdd": CustomerCentralDatabaseAdd,
    "CustomerMyCustomersList": CustomerMyCustomersList,
    "CustomerMyCustomersDetail": CustomerMyCustomersDetail,
    "CustomerAllPartnersList": CustomerAllPartnersList,
    "CustomerAllPartnersDetail": CustomerAllPartnersDetail,
    "CustomerMyBusinessByCustomerList": CustomerMyBusinessByCustomerList,
    "CustomerMyBusinessByCustomerDetail": CustomerMyBusinessByCustomerDetail,
    "CustomerMyBusinessByStateList": CustomerMyBusinessByStateList,
    "CustomerAllBusinessByCustomerList": CustomerAllBusinessByCustomerList,
    "CustomerAllBusinessByCustomerDetail": CustomerAllBusinessByCustomerDetail,
    "CustomerAllBusinessByStateList": CustomerAllBusinessByStateList,
    "CustomerMyAcquisitionByCustomerList": CustomerMyAcquisitionByCustomerList,
    "CustomerMyAcquisitionByCustomerDetail": CustomerMyAcquisitionByCustomerDetail,
    "CustomerMyAcquisitionByStateList": CustomerMyAcquisitionByStateList,
    "CustomerAllAcquisitionByCustomerList": CustomerAllAcquisitionByCustomerList,
    "CustomerAllAcquisitionByCustomerDetail": CustomerAllAcquisitionByCustomerDetail,
    "CustomerAllAcquisitionByStateList": CustomerAllAcquisitionByStateList,
    "CrmCommunicationNewTaskHub": CrmCommunicationNewTaskHub,
    "CrmCommunicationTicketsList": CrmCommunicationTicketsList,
    "CrmCommunicationMyAgendaList": CrmCommunicationMyAgendaList,
    "CrmCommunicationCompleteList": CrmCommunicationCompleteList,
    "CrmCommunicationTicketsList_MyAgenda": CrmCommunicationMyAgendaList,
    "CrmCommunicationTicketsList_CompleteList": CrmCommunicationCompleteList,
    "CrmCommunicationTicketList_MyAgenda": CrmCommunicationMyAgendaList,
    "CrmCommunicationTicketList_CompleteList": CrmCommunicationCompleteList,
    "CrmCommunicationTicketDetail": CrmCommunicationTicketDetail,
    "CrmCommunicationTicketForm": CrmCommunicationTicketForm,
    "PreviewCrmCommunication": PreviewCrmCommunication,
    //PRIDAT DALSIE JS SUBORY
};

/** V pätičke zobrazujeme striktne interný kód masky. */
function maskCodeLabel(mask) {
  if (mask == null || mask === '') return '';
  return String(mask);
}

function TabPanelList() {

  const [state,dispatch] = useContext(DatabaseContext);
  const { t } = useContext(LocaleContext);

  const selectedMaskLabel = useMemo(() => maskCodeLabel(state?.selectedMask), [state?.selectedMask]);

    const changeTab = (event, newValue) => {
        console.log(newValue);
        dispatch({type:'change_tab',name:newValue});
    };

  const handleTabClose = (event, value) => {
    //prevencia pred prepinam medzi tabmi pri mazani
    event.stopPropagation();
    dispatch({type:'close_tab',id:value});

    /*setTabs(tabs => tabs.filter(x => x.value !== value))
    setPanels(panels => panels.filter(p => p.value !== value));
    console.log("BEFORE SELECTED: "+selectedTab);
    if(selectedTab!=='1')setSelectedTab('1');
    console.log("AFTER SELECTED: "+selectedTab);*/
}



return (
<StyledEngineProvider injectFirst>
  <div className='h-[calc(100vh-64px)] flex flex-col overflow-hidden'>
    <div className='flex-1 min-h-0 flex flex-col overflow-hidden'>
      <TabContext value={state.selectedTab}>
        {/* maxWidth: { xs: 320, sm: 600, md: 900, lg: 1200, xl: 1536,  } */}
        <div className='w-full bg-[#f6f6f6] flex justify-center border-t-[1px] border-b-[1px] border-[#d1d1d1]'>
          <Box>{/*sx={{ maxWidth: { xs: 320, sm: 600, md: 900, lg: 1200, xl: 1536,  }}} */}
            <TabList onChange={changeTab} aria-label="lab API tabs example" variant="scrollable" scrollButtons={true}>
                {/*<Tab label="Create New" value="1" />
                <Tab   
                icon={
                    <HomeIcon/>
                } iconPosition='start'
                key="1" label="HomePage" value="1" />*/}
                {state.tabs.map(tab => {
                    if (tab.value == 1) {
                         return <Tab sx={{
                            color: '#333',
                            backgroundColor: '#f9f9f9',
                            py: 1,
                          }}
                            icon={
                                <HomeIcon/>
                            } iconPosition='start'
                            key="1" label={t("HomePage")} value="1" />;
                    }
                    if (tab.value == 2) {
                        return <Tab sx={{
                            color: 'black',
                            backgroundColor: '#f9f9f9',
                            position: 'absolute',
                            left: '-1000px'
                          }}
                        key={tab.value} label={t('ProfilePage.Title')} value={tab.value}/>;
                   }
                   return <Tab sx={{
                        color: 'black',
                        backgroundColor: '#f9f9f9',
                    }}
                    icon={
                        <CloseIcon onClick={(e) => handleTabClose(e, tab.value)} />
                    } iconPosition='end'
                    key={tab.value} label={resolveTabLabel(tab, t)} value={tab.value}/>;
                })}
            </TabList>
          </Box>
        </div>
            {/*<TabPanel value="1">
                <Button 
                    onClick={createNewTab}
                    variant='contained' color='primary'>
                    Create Dynamic Tab
                </Button>
                </TabPanel>
                <TabPanel key="1" value="1">
                    <HomePage/>
                </TabPanel>*/}
        <div className='flex-1 min-h-0 overflow-hidden'>
          {state.panels.map((panel) => {
            const Page = components[panel.child || 'HomePage'];
            //if(panel.props)console.log(panel.props);
            return <TabPanel key={panel.value} value={panel.value}>
            <Page {...panel.props}/>
        </TabPanel>;
          } )}
        </div>
      </TabContext>
    </div>
    <div className='w-full h-[21px] shrink-0 text-sm'>
            <hr className='h-1 w-full bg-gray-200'/>
            <div className='flex flex-row'>
                <div className='basis-3/5'></div>
                <span className='basis-1/5 border-x-2 px-2'>{t('ServiceTask.MaskNumber')}: {selectedMaskLabel}</span>
                <div className='basis-1/5'></div>
            </div>  
    </div>
  </div>
</StyledEngineProvider>
    )
}

export default TabPanelList;